module.exports = __webpack_public_path__ + "static/media/estilo3.64c04b06.png";